import axiosInstance from "../../config/axiosInstance";

export const getCountsRequest = async () => {
  return await axiosInstance.dillApi().get("/operations/count");
};
